import {globalWindow} from '../../../../libs/shared/helpers/src/browser/browserHelpers';
import {ErrorWithData, ExtendedError} from '../../../../libs/shared/helpers/src/types/customErrors';
import {leaveBreadcrumb, reportToBugsnag} from '../../../../srcCommon/services/bugsnag/bugsnag';

let currentRegistration: ServiceWorkerRegistration | null = null;
export function setCurrentRegistration(registration: ServiceWorkerRegistration) {
  currentRegistration = registration;
}

export function reloadServiceWorker(): void {
  if (!currentRegistration) {
    reportToBugsnag(new Error('Asked to reload service worker without registration'));
    return;
  }

  const waitingWorker = currentRegistration.waiting;
  if (!waitingWorker) {
    reportToBugsnag(
      new ErrorWithData(
        'Asked to reload service worker without a waiting worker',
        collectServiceWorkerErrorData(),
      ),
    );
    return;
  }

  waitingWorker.addEventListener('statechange', () => {
    leaveBreadcrumb(`Waiting service worker state changed to ${waitingWorker.state}`);
  });

  waitingWorker.addEventListener('error', (event) => {
    reportToBugsnag(new ExtendedError('Waiting service worker encountered an error', event.error));
  });

  // Tell the waiting service worker to skipWaiting
  waitingWorker.postMessage({type: 'SKIP_WAITING'});
  leaveBreadcrumb('Sent SKIP_WAITING to waiting service worker');
}

export function collectServiceWorkerErrorData() {
  return {
    registration: currentRegistration
      ? {
          hasInstalling: Boolean(currentRegistration.installing),
          hasWaiting: Boolean(currentRegistration.waiting),
          hasActive: Boolean(currentRegistration.active),
        }
      : undefined,
  };
}

export function isWaitingServiceWorker() {
  return Boolean(currentRegistration && currentRegistration.waiting);
}

export async function unregisterServiceWorker() {
  const registrations = await globalWindow.navigator.serviceWorker.getRegistrations();
  await Promise.all(registrations.map((registration) => registration.unregister()));
}
